var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.57784 7.34107L5.06684 6.77872H16.644V20.3625L16.1068 20.9803L16.786 21.5709L16.1068 20.9803L15.6178 21.5426H4.04063V7.95887L4.57784 7.34107Z",
    stroke: "black",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5773 3.61037L9.79722 3.35746H20.0643V15.7047L19.748 16.0685L19.5281 16.3214H18.982V18.1214H20.3482L21.1063 17.2496L21.8643 16.3778V3.35746V1.55746H20.0643H8.97709L8.21901 2.42925L7.46094 3.30104V4.43823H9.26094V3.97419L9.5773 3.61037Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyBlack);
export default __webpack_public_path__ + "static/media/copy-black.6b5289df8480a76a3bcee1e05430142b.svg";
export { ForwardRef as ReactComponent };